<template>
	<LazyAtomLink
		v-if="to"
		v-bind="to"
		:class="[
			'transition-colors duration-200 backdrop-blur-xl flex items-center text-left border',
			{
				'bg-purple-900/50 hover:bg-purple-800/50 border-purple-500/20 text-white': variant === CardButtonVariant.Brand,
				'bg-green-500/50 hover:bg-green-600/50 border-green-300/20 text-white': variant === CardButtonVariant.Green,
				'bg-black/20 hover:bg-black/50 border-white border-2 text-white': variant === CardButtonVariant.LightBorder,
			},
		]"
		role="button"
		@click.stop="onClick"
	>
		<span
			:class="[
				'flex flex-col gap-2 py-6 lg:py-8 px-8 lg:px-12 grow border-r-2',
				{
					'border-purple-500/20': variant === CardButtonVariant.Brand,
					'border-green-300/20': variant === CardButtonVariant.Green,
					'border-white': variant === CardButtonVariant.LightBorder,
				},
			]"
		>
			<span class="text-functional-size-md font-display text-white/70">
				{{ label }}
			</span>
			<span class="text-title-size-lg font-display md:text-title-size-xl">
				{{ text }}
			</span>
		</span>
		<span class="flex items-center h-full px-8">
			<AtomFontAwesome
				:icon="icon"
				class="w-8 h-8 text-white"
			/>
		</span>
	</LazyAtomLink>
	<button
		v-else
		:class="[
			'transition-colors duration-200 backdrop-blur-xl flex items-center text-left border',
			{
				'bg-purple-900/50 hover:bg-purple-800/50 border-purple-500/20 text-white': variant === CardButtonVariant.Brand,
				'bg-green-500/50 hover:bg-green-600/50 border-green-300/20 text-white': variant === CardButtonVariant.Green,
				'bg-black/20 hover:bg-black/50 border-white border-2 text-white': variant === CardButtonVariant.LightBorder,
			},
		]"
		type="button"
		@click.stop="onClick"
	>
		<span
			:class="[
				'flex flex-col gap-2 py-6 lg:py-8 px-8 lg:px-12 grow border-r-2',
				{
					'border-purple-500/20': variant === CardButtonVariant.Brand,
					'border-green-300/20': variant === CardButtonVariant.Green,
					'border-white': variant === CardButtonVariant.LightBorder,
				},
			]"
		>
			<span class="text-functional-size-md font-display text-white/70">
				{{ label }}
			</span>
			<span class="text-title-size-lg font-display md:text-title-size-xl">
				{{ text }}
			</span>
		</span>
		<span class="flex items-center h-full px-8">
			<AtomFontAwesome
				:icon="icon"
				class="w-8 h-8 text-white"
			/>
		</span>
	</button>
</template>

<script lang="ts" setup>
import type { FontAwesomeIconType } from '#base/app/plugins/fontawesome';
import { CardButtonVariant } from '#base/core/enums/CardButtonVariantEnum';
import type { UrlType } from '#base/core/types/UrlType';

const props = withDefaults(
	defineProps<{
		variant?: CardButtonVariant;
		to?: UrlType;
		label: string;
		text: string;
		icon: FontAwesomeIconType;
		isDisabled?: boolean;
	}>(),
	{
		variant: CardButtonVariant.Brand,
	}
);

const emit = defineEmits(['click', 'disabledClick']);

const onClick = (e: MouseEvent) => {
	if (props.isDisabled) {
		emit('disabledClick', e);
	}
	else {
		emit('click', e);
	}
};
</script>
